// extracted by mini-css-extract-plugin
export default {"container":"Push_container__wH63c","content":"Push_content__pPerg","no-padding":"Push_no-padding__GtkDY","wrap":"Push_wrap__-57v9","hint":"Push_hint__5ZcCI"};